import Vue, { CreateElement } from 'vue';
import { VAlert, VBtn } from 'vuetify/lib';
import { Prop, Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import HeaderMixins from '@/core/headerMixins';
import './alert.styl';

@Component({
  name: 'Alert',
})
export default class Alert extends mixins(Vue, HeaderMixins) {
  @Prop({type: Boolean, default: false}) public readonly fixed!: boolean;
  @Prop({type: String, default: 'error'}) public readonly type!: string;
  @Prop({type: String, default: ''}) public readonly closeButtonName!: string;
  @Prop({type: String, default: ''}) public readonly message!: string;
  @Prop({type: Boolean, default: false}) public readonly value!: boolean;
  @Prop({type: Number, default: 4000}) public readonly timeout!: number;
  @Prop({type: Number, default: 750}) public readonly speed!: number;

  public get animationHeight(): number {
    return 156;
  }

  @Watch('$route')
  public closeMessage(): void {
    this.$emit('close');
  }

  private render(createElement: CreateElement) {

    return createElement('div', {
      class: [
        'alert-wrapper',
        this.fixed && 'fixed',
      ],
    }, [
      createElement('transition', {
        props: {
          css: false,
        },
        on: {
          beforeEnter: (el) => {
            el.style.transform = `translateY(-${this.animationHeight}px)`;
            el.style.visibility = 'visible';
            el.style.transition = `transform ${this.speed}ms cubic-bezier(0.215, 0.61, 0.355, 1)`;
          },
          enter: (el, done) => {
            requestAnimationFrame(() => {
              el.style.transform = 'translateY(0px)';
            });
            setTimeout(() => {
              done();
            }, this.speed);
          },
          leave: (el, done) => {
            el.style.transform = `translateY(-${this.animationHeight}px)`;
            setTimeout(() => {
              el.style.visibility = 'hidden';
              done();
            }, this.speed);
          },
        },
      }, [
        this.value &&
        createElement(VAlert, {
          class: 'central-alert',
          props: {
            tile: true,
            dismissible: true,
            value: true,
            type: this.type,
          },
        }, [
          this.message,
          createElement(VBtn, {
            on: {
              click: () => {
                this.closeMessage();
              },
            },
            props: {
              xSmall: true,
              depressed: true,
              color: 'error',
            },
            slot: 'close',
            }, [
                this.closeButtonName,
            ]),
        ]),
      ]),
    ]);
  }
}
